/**
 * 设备分组模块（OFBiz 新接口）
 * ------------------------------------------------------------------
 * 对应后端：POST /itoss/control/json/equipmentGroup/*
 *
 * 迁移自前端原接口（odata_client.js / odatayft.js）：
 *   getEccGroup / getGroupListData, createEccGroup, updateEccGroup, deleteEccGroup
 *
 * 字段映射：
 *   RecId          -> groupId
 *   GroupName      -> groupName
 *   ParentGroupId  -> parentGroupId
 *   Sorter         -> dateAcquired / sorter
 */
import { ofbiz } from './http';

/**
 * 分组列表/树（替代旧 getEccGroup / getGroupListData）
 * @param {object} [opts]
 * @param {boolean|string} [opts.isTree] 传 'true' 返回树形结构
 * @returns {Promise<Array|object>} 列表或树
 */
export function getGroupList({ isTree } = {}) {
  return ofbiz.post('equipmentGroup/list', null, { isTree });
}

/**
 * 分组详情
 * @param {string} groupId
 * @returns {Promise<object>}
 */
export function getGroupById(groupId) {
  return ofbiz.post('equipmentGroup/getById', null, { groupId });
}

/**
 * 新增分组（替代旧 createEccGroup）
 * @param {object} data { groupName(必填), parentGroupId }
 * @returns {Promise<object>}
 */
export function createGroup(data) {
  return ofbiz.post('equipmentGroup/create', data);
}

/**
 * 更新分组（替代旧 updateEccGroup）
 * @param {object} data { groupId(必填), groupName, parentGroupId }
 * @returns {Promise<object>}
 */
export function updateGroup(data) {
  return ofbiz.post('equipmentGroup/update', data);
}

/**
 * 删除分组（替代旧 deleteEccGroup）
 * @param {string} groupId
 * @returns {Promise<object>}
 */
export function deleteGroup(groupId) {
  return ofbiz.post('equipmentGroup/delete', null, { groupId });
}

/**
 * 批量移动设备到目标分组（替代旧 moveEquipments）
 * @param {string} targetGroupId 目标分组 ID
 * @param {string|string[]} deviceIds 设备 ID，逗号分隔字符串或数组
 * @returns {Promise<object>}
 */
export function moveDevices(targetGroupId, deviceIds) {
  const ids = Array.isArray(deviceIds) ? deviceIds.join(',') : deviceIds;
  return ofbiz.post('equipmentGroup/moveDevices', { targetGroupId, deviceIds: ids });
}
